import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  Input,
  OnChanges,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EquipmentPhotoService } from '../../services/equipment-photo.service';

@Component({
  selector: 'app-equipment-photo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './equipment-photo.component.html',
  styleUrl: './equipment-photo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EquipmentPhotoComponent implements OnChanges {
  @Input() src?: string | null;
  @Input() alt = 'Fotografia do equipamento';
  @Input() fallbackIcon = 'pi pi-box';
  @Input() fallbackLabel = '';

  private readonly photoService = inject(EquipmentPhotoService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly cdr = inject(ChangeDetectorRef);
  private requestVersion = 0;

  resolvedSrc: string | null = null;
  loading = false;

  ngOnChanges(): void {
    const version = ++this.requestVersion;
    this.resolvedSrc = null;
    this.loading = !!this.src;

    this.photoService
      .resolve(this.src)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((url) => {
        if (version !== this.requestVersion) return;
        this.resolvedSrc = url;
        this.loading = false;
        this.cdr.markForCheck();
      });
  }

  onImageError(): void {
    this.resolvedSrc = null;
    this.loading = false;
    this.cdr.markForCheck();
  }
}
